import script from "./app-footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-footer.vue?vue&type=script&lang=ts&setup=true"

import "./app-footer.vue?vue&type=style&index=0&id=1da9d09e&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/sz-cd-pro4kg65/portal-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da9d09e"]])

export default __exports__